module.exports = __webpack_public_path__ + "img/emoji_047.768d75e6.png";